Genoverse.Track.File.WIG = Genoverse.Track.Graph.Bar.extend({
  model  : Genoverse.Track.Model.File.WIG,
  name   : 'wig',
  height : 100
});
